import zappy from "@zappy-ride/library.react.components";
import { OutputOperation } from './Operations';

export * from "./Operations";

zappy.FactoryInstance.registerComponent(OutputOperation);